import YoutubeVideo from './YoutubeVideo';
import TwitterVideo from './TwitterVideo';
import InstagramVideo from './InstagramVideo';
import MediaViewer from './MediaViewer';

customElements.define('instagram-video', InstagramVideo);
customElements.define('youtube-video', YoutubeVideo);
customElements.define('twitter-video', TwitterVideo);
customElements.define('media-viewer', MediaViewer);
